import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const repliesResolver: FieldResolver = (metadata: Metadata) =>
  ({ replies: metadata.getReplies() } as StreamData)

export default repliesResolver
